import React from 'react';

import {StyledModalFooter} from 'app/components/general/TabbedModal';
import {FormControlGroup} from 'app/general/forms';
import {CreateUserModal} from 'app/user/components/CreateUserForm/CreateUserModal';
import {SelectUsersMulti} from 'app/user/components/select/SelectUsers';
import {getContentType} from 'app/utils/content-type';
import {getObjectName} from 'app/utils/fallbacks';
import {gt} from 'app/utils/i18n';

import {UserSerializedType} from 'sweet-types';

import type {NewInvitationType, ShareableContentType} from 'app/user/types';

interface Props {
  objectId: number;
  name: string;
  contentType: ShareableContentType;
  onConfirm: (invites: NewInvitationType[]) => void;
  onCancel: () => void;
}

export function ShareWithTeammateModalPane({
  objectId,
  name,
  contentType,
  onConfirm: onConfirmProp,
  onCancel,
}: Props): JSX.Element {
  const [message, setMessage] = React.useState('');
  const [selected, setSelected] = React.useState<Array<UserSerializedType>>([]);
  const [show, setShow] = React.useState<boolean>(false);

  function handleChange(selected: UserSerializedType[]) {
    setSelected(selected);
    return Promise.resolve(true);
  }

  function onConfirm() {
    if (selected.length !== 0) {
      onConfirmProp(
        selected.map((user) => ({
          object_id: objectId,
          content_type: contentType,
          message: message,
          to_user_id: user.url,
        }))
      );
    }
  }

  const translationArgs = {
    name: (
      <b>
        {getObjectName(
          {
            name,
          },
          contentType,
          true
        )}
      </b>
    ),
    ct: getContentType(contentType).name,
  };
  return (
    <div>
      <p>
        {gt(
          'Enter the name of teammates to give them access to the %(name)s %(ct)s',
          translationArgs
        )}
      </p>
      <FormControlGroup field="name">
        <SelectUsersMulti onChange={handleChange} selected={selected} />
      </FormControlGroup>
      <FormControlGroup field="message">
        <textarea
          className="form-control"
          value={message}
          onChange={(event) => setMessage(event.target.value)}
          name="message"
          placeholder={gt('Message (optional)')}
        />
      </FormControlGroup>

      <CreateUserModal
        show={show}
        setShow={setShow}
        onCreateUser={(user) => {
          handleChange([user]);
          setShow(false);
          return Promise.resolve(true);
        }}
      />

      <StyledModalFooter>
        <a
          onClick={onCancel}
          className="btn btn-link text-secondary"
          data-dismiss="modal"
        >
          <i className="fa fa-times mr-1" /> {gt('Cancel')}
        </a>
        <div>
          <button className="btn btn-link" onClick={() => setShow(true)}>
            {gt('Invite new member')}
          </button>
          <button
            className="btn btn-primary"
            onClick={onConfirm}
            disabled={selected.length === 0}
          >
            {gt('Share')}
          </button>
        </div>
      </StyledModalFooter>
    </div>
  );
}
